import { IStorage } from './index';

/**
 * Cookie based key value pair storage.
 * When storing the cookies we will prefix "joy" to the key and URICompoenent encode the value
 * The key is modified for easy debugging so that all cookies will start with Joy.
 * The value is modified because we dont want = and ; get into it otherwise it might mess up our parsing
 * @constructor
 */
export class CookieStorage implements IStorage {

    public getItem(key: string) {
        let pair = window.document.cookie.split(";")
            .map(function (c) {
                return c.split("=");
            })
            .map(function (pair) {
                pair[0] = pair[0].trim();
                return pair;
            })
            .find(function (pair) {
                return pair[0] == ("joy" + key);
            });
    
        if (!pair) {
            return null;
        }
        return decodeURIComponent(pair[1]);
    }

    public setItem(key: string, value: string) {
        let shouldDelete = (typeof value == "undefined" || value === null);
        let keyInCookie = "joy" + key;
        let valueInCookie = shouldDelete ? "" : encodeURIComponent(value);
        let expInCookie = shouldDelete ? "expires=Thu, 01 Jan 1970 00:00:01 GMT;" : "";
        let secureInCookie = (window.location.protocol == "https") ? "secure;": "";
        let pathInCookie = "path=/;";
        let cookie = [
                keyInCookie + "=" + valueInCookie + ";",
                expInCookie,
                pathInCookie,
                secureInCookie
            ].join("");
    
            window.document.cookie = cookie;
    }
}